import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fui-color-pair-view",
    templateUrl: "./color-pair-view.component.html",
    styleUrls: ["./color-pair-view.component.scss"]
})
export class FUIColorPairViewComponent {
    @Input() foregroundColor: string;
    @Input() backgroundColor: string;
    @Input() propagateClick: boolean = false;
    @Output() onForegroundClick: EventEmitter<void> = new EventEmitter<void>();
    @Output() onBackgroundClick: EventEmitter<void> = new EventEmitter<void>();

    foregroundClicked(event: MouseEvent) {
        if (!this.propagateClick) {
            event.stopPropagation();
        }
        this.onForegroundClick.next();
    }

    backgroundClicked(event: MouseEvent) {
        if (!this.propagateClick) {
            event.stopPropagation();
        }
        this.onBackgroundClick.next();
    }
}
